module.exports = __webpack_public_path__ + "img/valores.87dff7a3.svg";